import React, { useMemo } from 'react'

import Flex from 'styled-flex-component'

import { IOption } from '@store/rootResource/types'
import Theme from '@theme'
import { Container, Select, Text } from '@tribegroup'

interface IAnalyticsBreakdownFilterOption {
  selected: IOption
  onChange: (option: IOption) => void
  options: IOption[]
  filterLabel: string
}

export type IAnalyticsBreakdownFilterProps = {
  filters?: Record<string, IAnalyticsBreakdownFilterOption>
}

export const AnalyticsBreakdownFilter: React.FC<IAnalyticsBreakdownFilterProps> = ({ filters }) => {
  if (!filters || Object.keys(filters).length === 0) {
    return null
  }

  const filterEntries = useMemo(() => Object.entries(filters), [filters])

  return (
    <Container
      bottomOuterSpacing={2}
      data-testid="analytics-breakdown-filter"
      borderColor={Theme.grey400Color}
      borderWidthTop={0.0625}
      borderWidthBottom={0.0625}
      topInnerSpacing={1.5}
      bottomInnerSpacing={1.5}
      topOuterSpacing={2}
    >
      <Flex alignCenter>
        <Container width={10.5} rightOuterSpacing={2}>
          <Text customFontSize={1} color={Theme.grey900Color}>
            Filter data
          </Text>
        </Container>
        <Flex>
          {filterEntries.map(([key, filter], index) => (
            <Container
              width={20}
              key={`${key}-filter`}
              rightOuterSpacing={index === filterEntries.length - 1 ? 0 : 1}
              data-testid={`${key}-select`}
            >
              <Select
                thick
                rsConfig={{
                  value: filter.selected,
                  options: filter.options,
                  onChange: (option) => {
                    if (option) {
                      filter.onChange(option)
                    }
                  },
                  isSearchable: false,
                  formatOptionLabel: ({ label }, { context }) => {
                    if (context === 'menu') {
                      return label
                    }
                    return (
                      <>
                        {filter.filterLabel}: <strong>{label}</strong>
                      </>
                    )
                  },
                }}
                backgroundColor="transparent"
              />
            </Container>
          ))}
        </Flex>
      </Flex>
    </Container>
  )
}
